var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "school_FILL0_wght100_GRAD-25_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94732 15.7205L11.5165 19.2381L18.0856 15.7205V10.6516L20.2998 9.50705V12.332V15.1569L19.1429 14V14.9524L20.5714 16.381L22 14.9524V14L21.0476 14.9524V12.0155V9.07868L11.5165 4L2 9.07456L4.94732 10.6459V15.7205ZM19.464 9.07456L11.5165 13.3274L3.58364 9.07456L11.5165 4.83615L19.464 9.07456ZM17.3378 15.3073L11.5165 18.3875L5.69515 15.3073V11.064L11.5165 14.1635L17.3378 11.064V15.3073Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/School.a6b553c0e541176ca3c4664b6c2e17a8.svg";
export { ForwardRef as ReactComponent };